module.exports = __webpack_public_path__ + "Flag-612.deeda4a0edb3f9c2f7c73418de7d1853.svg";